// EXAMPLE USAGE: div class="card"  v-async-image="'PWACard_vue_bg'"
import { defineNuxtPlugin } from '#app'
import { getImage, imageStore } from '~/composables/useImagePrefetch'
import { watch } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('asyncImage', {
    mounted(el, binding) {
      const key = typeof binding.value === 'function'
        ? binding.value()
        : binding.value

      if (!key) return

      // initial render if already in store or DB
      updateImage(el, key)

      // reactively update when imageStore gets a value for this key
      watch(
        () => imageStore.get(String(key)),
        (url) => { 
          /*console.log('Watcher fired for', key, url)*/
          if (url) applyToElement(el, url)
        }
      )
    },
    unmounted(el) {
      if (el._stopAsyncImageWatch) el._stopAsyncImageWatch()
    },
    updated(el, binding) {
      const key = typeof binding.value === 'function'
        ? binding.value()
        : binding.value

      if (!key) return
      updateImage(el, key)
    }
  })

  async function updateImage(
    el: HTMLElement,
    keyOrFn: string | (() => string)
  ) {
    const key =
      typeof keyOrFn === 'function' ? keyOrFn() : keyOrFn

    if (!key) return

    try {
      const url = await getImage(key)
      if (!url) {
        //console.error('Plugin [v-async-image] reports getImage returned nothing yet for key:', key)
        return
      }

      applyToElement(el, url)
    } catch (e) {
      console.error('v-async-image error', e)
    }
  }

  function applyToElement(el: HTMLElement, url: string) {
    if (el.tagName === 'IMG') {
      ;(el as HTMLImageElement).src = url
    } else {
      const s = el.style
      s.backgroundImage    = `url(${url})`
      s.backgroundRepeat   = 'no-repeat'
      s.backgroundPosition = 'center'
      s.backgroundSize     = 'contain'
    }
  }
})
